import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useExamStatus } from "./ExamStatusContext"; // ExamStatusContextを使用
import { useToken } from "../TokenContext"; // TokenContextを使用
import "../../css/GATBstart.css";
import GATBCaution from "../../voice/GATBstart.wav";

const GATBstart = () => {
  const [name, setName] = useState("");
  const [grade, setGrade] = useState("中学生");
  const [gender, setGender] = useState("男");
  const { examStatus, setExamStatus } = useExamStatus(); // 状態管理を使用
  const navigate = useNavigate();
  const audioRef = useRef(null);

  const initializeScores = () => {
    ["G", "V", "N", "Q"].forEach((k) => localStorage.setItem(`${k}_score`, 8));
    ["S", "P"].forEach((k) => localStorage.setItem(`${k}_score`, 10));
    localStorage.setItem("K_score", 100);
    localStorage.setItem("F_score", 102);
    localStorage.setItem("M_score", 102);
  };

  useEffect(() => {
    // ページロード時に名前と学年を取得
    const storedName = localStorage.getItem("userName");
    const storedGrade = localStorage.getItem("grade");
  
    if (storedName) setName(storedName);
    if (storedGrade) {
      setGrade(storedGrade); // ここでユーザーの選択を維持
    } else {
      // ない場合のみ初期化
      setGrade("中学生");
      localStorage.setItem("grade", "中学生");
    }
  
    if (examStatus === "検査中") {
      setExamStatus("検査前");
    }
  
    initializeScores();
  }, [examStatus, setExamStatus]);
  
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
    }
        
    audioRef.current = new Audio(GATBCaution);
    audioRef.current.play().catch((error) => {
      console.error("音声再生に失敗しました:", error);
    });
        
    return () => {
      if (audioRef.current) audioRef.current.pause();
    };
  }, []);

  const { companyName_findjob } = useToken();

  const handleGradeChange = (e) => {
    const selectedGrade = e.target.value;
    setGrade(selectedGrade);
    localStorage.setItem("grade", selectedGrade); // 選択された学年を保存
  };

  const handleStartTest = () => {
    setExamStatus("検査中"); // 状態を更新
    navigate("/GATBtest"); // 次のページに遷移
  };

  return (
    <div className="gatb-container">
      <h1>厚生労働省編一般職業適性検査（GATB）</h1>
      <div className="gatb-inputs">
        <label>
          <strong>名前:</strong> {name}
        </label>
        <label>
          <strong>所属:</strong> {companyName_findjob}
        </label>
        <label>
          <strong>区分:</strong>
          <select
            value={grade}
            onChange={handleGradeChange}
            className="gatb-select"
          >
            <option value="中学生">中学生</option>
            <option value="高校生">高校生</option>
            <option value="大学生">大学生</option>
            <option value="その他">その他</option>
          </select>
        </label>
        <label>
          <strong>性別:</strong>
          <select
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            className="gatb-select"
          >
            <option value="男">男</option>
            <option value="女">女</option>
          </select>
        </label>
      </div>

      <div className="gatb-warning">
        <strong>検査を始める前に:</strong>
        <ul>
          <li>この検査では、あなたの職業適性を知る9種類の検査を行います。</li>
          <li>
            どの検査も限られた短い時間の中で、どれくらい多く間違えずにできるかを調べるようになっています。<br />
            問題数が多いので全部は出来ないかもしれませんが、できるだけたくさんできるよう頑張りましょう。
          </li>
          <li>
            どの検査でも、始める前に<strong>「やり方」</strong>の説明があります。<br />
            正しいやり方を理解して、問題を解いていきましょう。
          </li>
          <li>本検査にはそれぞれ制限時間があります。終了後はブラウザのバックボタンや更新等でやり直す事はしないで下さい。</li>
          <li>問題は番号順にやりましょう。</li>
          <li>問題が見にくい場合は、画面右に拡大・縮小ボタンが出ますので活用して下さい。</li>
          <li>別途、紙とペンを用意しておきましょう。</li>
        </ul>
      </div>

      <button onClick={handleStartTest} className="gatb-button">
        検査に進む
      </button>
    </div>
  );
};

export default GATBstart;
